import dayjs from "dayjs";
import "dayjs/locale/id";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("id");

/**
 * format date return a formated string date based on format you provide
 * @param {string | number} value your date value
 * @param {string} format your date format, refer to [dayjs](https://day.js.org/docs/en/display/format) for more info
 * @returns {string} formated date string
 * @example
 * formatDate("2020-01-01", "DD MMMM YYYY"); // 01 Januari 2020
 */

type FormatDateType = {
  value: string | number | Date;
  format: string;
  timezone?: string;
  withTimeZone?: boolean;
};

export default function formatDate(
  value: FormatDateType["value"],
  format: FormatDateType["format"],
  withTimeZone: FormatDateType["withTimeZone"] = false,
  timezone: FormatDateType["timezone"] = "UTC",
) {
  if (!withTimeZone) {
    return dayjs(value).format(format);
  }
  return dayjs(value).tz(timezone).format(format);
}
